import React from 'react';
import PropTypes from 'prop-types';
import PatientEventTable from './PatientEventTable';
import PatientServiceGroupTable from './PatientServiceGroupTable';
import {
    Box,
    Container,
    Typography,
    makeStyles
} from '@material-ui/core';
import useStyles from 'src/components/TableComponent/style';

const useLayoutStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  sectionTitle: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(4)
  }
}));

const RequestList = ({ className, users, ...rest }) => {
    const classes = useStyles(); 
    const layoutClasses = useLayoutStyles(); 
    
    return (
        <Box className={layoutClasses.root}>
            <Container maxWidth="lg">
                
                <Typography variant="h1" color="textPrimary" gutterBottom>
                    Appuntamenti
                </Typography>
                
                <Typography variant="h3" color="textSecondary" className={layoutClasses.sectionTitle}>
                    I tuoi prossimi appuntamenti individuali
                </Typography>

                <PatientEventTable />

                <Typography variant="h3" color="textSecondary" className={layoutClasses.sectionTitle}>
                    I tuoi prossimi appuntamenti di gruppo
                </Typography>

                <PatientServiceGroupTable />

            </Container>        
        </Box>
    );
};

RequestList.propTypes = {
    className: PropTypes.string,
    users: PropTypes.array
};

RequestList.defaultProps = {
    users: []
};

export default RequestList;